import { Container } from 'react-bootstrap'
import styled from 'styled-components'
import getConfig from 'next/config'
import { color, space, typography, layout } from 'styled-system'
import Text from './shared/typography/Text'
import Header from './shared/typography/Header'
import { emitGA } from '../utils/gtm'
import { themeGet } from '@styled-system/theme-get'
import Button from './shared/Button'
import { showFBChat } from '../utils/facebook'
import { withTranslation } from '../i18n' // should use the same constant from i18n custom
import { Parallax } from 'react-parallax'

const Root = styled.div`
  ${space}
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`
Root.defaultProps = {
  pt: [100, 200],
  pb: [100, 200]
}

const Title = styled(Header)`
  color: ${themeGet('colors.light-1')};
`
Title.defaultProps = {
  variant: ['header.regular', null, null, 'header.medium'],
  textAlign: ['left', null, null, 'center']
}

const Subtitle = styled(Text)`
  color: ${themeGet('colors.light-1')};
`
Subtitle.defaultProps = {
  variant: ['text.regular', null, null, 'text.medium'],
  textAlign: ['left', null, null, 'center']
}

const Actions = styled.div`
  width: 100%;
  text-align: center;
`

const ContactButton = styled(Button)`
  ${color}
  ${typography}
  ${layout}
  ${space}
  margin-bottom: 16px;
`
ContactButton.defaultProps = {
  variant: 'secondary',
  width: ['100%', null, null, 320],
  mr: [0, null, null, 24]
}

const RegisterButton = styled(Button)`
  ${color}
  ${typography}
  ${layout}
  margin-bottom: 16px;
`
RegisterButton.defaultProps = {
  variant: 'transparent',
  width: ['100%', null, null, 320]
}

const { publicRuntimeConfig } = getConfig()

const ContactSection = ({ t }) => {
  const handleClickWithEvent = event => emitGA(event, { section: 'ContactUs' })
  const handleClickContactBtn = () => {
    handleClickWithEvent('HOMEPAGE_CHAT')
    showFBChat()
  }

  return (
    <Parallax
      bgImage="public/images/index/contact-buildings.jpg"
      bgImageAlt="the cat"
      strength={500}
      style={{ scrollSnapAlign: 'start' }}
    >
      <Root>
        <Container>
          <Title mb={24}>{t`Liên hệ với chúng tôi để được tư vấn ngay!`}</Title>
          <Actions>
            <ContactButton onClick={handleClickContactBtn}>
              {t`Nhận Tư Vấn Ngay`}!
            </ContactButton>

            <a href={`${publicRuntimeConfig.BASE_URL}/signup`}>
              <RegisterButton
                onClick={() => handleClickWithEvent('HOMEPAGE_SIGNUP')}
              >
                {t`Đăng Ký Tài Khoản`}
              </RegisterButton>
            </a>
          </Actions>
        </Container>
      </Root>
    </Parallax>
  )
}

export default withTranslation('common')(ContactSection)
